module.exports = __webpack_public_path__ + "img/15.df07634f.jpg";